<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-scadenzari page-operative-data-analysis-scadenzari-edit">
    <div class="container">
      <PageTitle>Modifica scadenzario</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Scadenzario da modificare non trovato</div>
      <FormFinanziamento v-else-if="company && userCanEdit" :scadenzario.sync="scadenzario" edit @saved="saveScadenzario" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-scadenzario-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormFinanziamento: () => import('../../../../components/Operative/Form/FormFinanziamento'),
  },
  data () {
    return {
      scadenzario: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveScadenzario (scadenzario) {
      this.$api.updateScadenzario(this.company.id, scadenzario.id, scadenzario)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.scadenzari',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getScadenzario(this.company.id, this.$route.params.scadenzarioId)
          .then(res => {
            this.scadenzario = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
